import { EncryptionService } from '@afe/encryption';
import { Injectable } from '@angular/core';
// @ts-ignore
import { JSEncrypt } from 'jsencrypt';
import { urlConfig } from '../../../../config/url.config';

@Injectable()
export class SecurityService {

    constructor(private encryption: EncryptionService) {}

    encryptK:string='';
    decryptK:string='';

    encrypt(textPlain: string): string {
        // @ts-ignore
        // return textPlain;
        let encrypt = new JSEncrypt();

        encrypt.setPublicKey(this.encryptK.length > 0 ? this.decode(this.encryptK) : this.decode(urlConfig.secret));

        return textPlain && textPlain.toString().trim().length > 0? encrypt.encrypt(textPlain) as string:textPlain;
    }

    decrypt(textEncrypted: string): string | boolean {
        // return textEncrypted;
        let decrypt = new JSEncrypt();
        decrypt.setPrivateKey(this.decryptK.length > 0 ? this.decode(this.decryptK) : this.decode(urlConfig.psecret));
        return textEncrypted && textEncrypted.toString().trim().length > 0? decrypt.decrypt(textEncrypted):textEncrypted;
    }

    encryptAFE(textPlain: string) {
        return this.encryption.encrypt(textPlain);
    }

    decryptAFE(textEncrypted) {
        return this.encryption.decrypt(textEncrypted);
    }

    decode(value:string){
        return atob(value);
    }
}
